import { LitEntity, html } from '../../utility/lit-entity';

class DevicesTotalCount extends LitEntity {
  constructor() {
    super();
    this.loadingDisplayStyle = 'icon-only';
    this.loadingDisplayWaitMS = 0;
  }

  static get properties() {
    return {
      maxcount: { type: Number },
      count: { type: Number, reflect: true },
    };
  }

  renderEntity() {
    return html`
      <span title=${this.count}>
        ${Math.min(this.entity?.properties?.totalCount, this.maxcount || this.entity?.properties?.totalCount)}
      </span>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!entity || typeof entity.properties.totalCount === 'undefined') {
      return;
    }

    this.count = entity.properties.totalCount;
  }
}

window.customElements.define('devices-total-count', DevicesTotalCount);
